package one.healthium.today.ui.period_tracker

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update
import one.healthium.domain.user.models.PeriodLogModel
import one.healthium.log_period.domain.PeriodTrackerInteractor
import one.healthium.log_period.models.getPeriodDay
import one.healthium.log_period.models.getPeriodDuration
import one.healthium.log_period.models.getPeriodPhase
import one.healthium.today.ui.models.PeriodPhaseUiModel
import one.healthium.today.ui.models.PeriodTrackerUiModel
import one.healthium.ui.common.vm.BaseViewModel

class PeriodTrackerViewModel(
    private val periodTrackerInteractor: PeriodTrackerInteractor,
) : BaseViewModel() {

    private val _state = MutableStateFlow(
        PeriodTrackerUiState(
            uiModel = todayUiModel(PeriodLogModel()),
        )
    )
    val state = _state.asStateFlow()

    init {
        launch {
            periodTrackerInteractor.observePeriodLog().collect {
                _state.update { state ->
                    state.copy(uiModel = todayUiModel(it))
                }
            }
        }
    }

    private fun todayUiModel(model: PeriodLogModel): PeriodTrackerUiModel {
        val periodDay = model.getPeriodDay()
        val periodPhase = PeriodPhaseUiModel(
            phase = model.getPeriodPhase(),
            cycleDay = periodDay,
            duration = model.getPeriodDuration()
        )

        val tip: String? = periodDay?.let(periodTrackerInteractor::getTipForDay)

        return PeriodTrackerUiModel(
            phase = periodPhase,
            tipText = tip,
        )
    }
}